<script setup lang="ts">
import { onBeforeMount, onMounted } from 'vue';

import { getConfigEntry } from '@/api/config';
import Container from '@/components/base/layout/Container.vue';

const loadHelpCenter = () => {
  const id = 'gladly-help-center-script';

  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = id;
  script.async = true;
  script.src = 'https://cdn.gladly.com/help-center/hcl.js';

  const a = document.getElementsByTagName('script')[0];
  if (a && a.parentNode) {
    a.parentNode.insertBefore(script, a);
  } else {
    document.body.appendChild(script);
  }
};

onBeforeMount(() => {
  const gladlyConfig = getConfigEntry('gladly');

  window.gladlyHCConfig = {
    api: gladlyConfig.baseUri,
    orgId: gladlyConfig.orgId,
    brandId: gladlyConfig.brandId,
    cdn: gladlyConfig.cdn,
    selector: '#gladly-help-center',
  };
});

onMounted(() => {
  loadHelpCenter();
});
</script>

<template>
  <Container>
    <div v-once id="gladly-help-center" />
  </Container>
</template>

<style>
#gladly-help-center {
  @apply mt-6 mb-20;
}

#gladly-help-center input {
  @apply rounded-full py-2 px-4 max-w-2xl my-2 mx-auto block;
}

#gladly-help-center h2 {
  @apply text-[40px] text-center;
}

#gladly-help-center h2.gladlyHC-faqHeading {
  @apply after:text-neutral-500 after:font-sofia-pro after:text-base/6 after:block after:max-w-2xl after:mx-auto after:my-4 after:normal-case;
}

#gladly-help-center h2.gladlyHC-faqHeading::after {
  content: "Have a nutty question? Search our Help Center for frequently asked questions. If you can't find the answer feel free to reach out to us by phone or email!";
}

#gladly-help-center h3 {
  @apply text-2xl/7 pb-4 mb-4 border-solid border-b border-neutral-300;
}

#gladly-help-center .gladlyHC-faqSection {
  @apply my-6 md:px-4;
}

#gladly-help-center li a {
  @apply text-black font-sofia-pro text-base/6 mb-4 hover:underline;
}

#gladly-help-center .gladlyHC-answerDetail-content {
  @apply border border-solid border-neutral-300 p-4 rounded-2xl md:p-8;
}
</style>
